const VENTAJAS_CARDS = [
  {
    img: `${process.env.PUBLIC_URL}/assets/imagenes/about/icocasa-33.png`,
    title: "Remoto",
    subtitle:
      "Ofrecemos trabajo remoto, lo que incrementa la productividad, mejora la conciliación entre vida laboral y personal, y reduce el estrés de los traslados. Esta flexibilidad facilita la retención del talento. ",
  },
  {
    img: `${process.env.PUBLIC_URL}/assets/imagenes/about/icoprocesos-34.png`,
    title: "Toma de fuerza ilimitada",
    subtitle:
      "Contamos con herramientas, formaciones y apoyo que permite al equipo perfeccionar sus habilidades, potenciando su capacidad de trabajo y facilitando la colaboración mutua. ",
  },
  {
    img: `${process.env.PUBLIC_URL}/assets/imagenes/about/icoreloj-35.png`,
    title: "Horario flexible",
    subtitle:
      "Brindamos la flexibilidad de trabajar en los momentos que más les conviene al equipo, lo que reduce el estrés, aumenta la productividad, mejora el clima laboral, aumenta su satisfacción y compromiso con la empresa",
  },
  {
    img: `${process.env.PUBLIC_URL}/assets/imagenes/about/icoidea-36.png`,
    title: "Crecimiento profesional",
    subtitle:
      "Fomentamos el crecimiento profesional del equipo con programas de formación continua y un entorno de trabajo que valora la innovación y el aprendizaje constante, para aportar valor a nuestros clientes y enfrentar nuevos desafíos.",
  },
  {
    img: `${process.env.PUBLIC_URL}/assets/imagenes/about/icocorazon-37.png`,
    title: "Buena cultura",
    subtitle:
      "Apostamos a la colaboración, la diversidad, la inclusión y el bienestar del equipo. Somos un espacio donde se valora tu voz y tu trabajo.",
  },
  {
    img: `${process.env.PUBLIC_URL}/assets/imagenes/about/icocolaboracion-40.png`,
    title: "Transparencia real",
    subtitle: "Compartimos lo que sabemos, escuchamos y construimos juntos.",
  },
];

export const Ventajas = () => {
  return (
    <section
      className="centered-section"
      style={{ marginTop: "8rem", position: "relative" }}
    >
      {/* <img
        src={`${process.env.PUBLIC_URL}/assets/imagenes/home/img_equipo2.png`}
        alt="simbolo-equipo"
        className="imagen-simbolo"
      /> */}
      <span
        className="horizontal gap-8"
        style={{
          color: "white",
          marginInline: "auto",
          width: "fit-content",
        }}
      >
        <span className="linea-negra"></span>
        <p className="datos-upper-text">
          Grandes equipos logran grandes innovaciones
        </p>
        <span className="linea-negra"></span>
      </span>
      <p
        className="section-title"
        style={{
          marginInline: "auto",
          textAlign: "center",
          margin: "2rem 0px",
        }}
      >
        <span style={{ color: "var(--red-highlight)" }}>Ventajas </span>
        de trabajar <br /> en binamics
      </p>

      <div className="ventajas-cards-layout">
        {VENTAJAS_CARDS?.map((element, index) => {
          return (
            <div className="ventajas-cards-wrapper" key={`ventajas-card-${index}`}>
              <img
                alt={"img-" + index}
                src={element.img}
                style={{
                  width: "4.5rem",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  transform: "translate(-50%, -50%)",
                }}
              />
              <p className="ventajas-card-title">{element.title}</p>
              <p className="card-text">
                {element.subtitle}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
};
